import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from "@angular/forms";
import * as CryptoJS from 'crypto-js';
import { GlobalVariable } from '../common/global';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';


import { AutoReportRequest } from '../dataObjects/AutoReportRequest';
import { AutoReportResponse } from '../dataObjects/AutoReportRequest';
import { AutoReportResponseList } from '../dataObjects/AutoReportRequest';
import { MatSidenav } from '@angular/material';

@Component({
  selector: 'app-autoreport',
  templateUrl: './autoreport.component.html',
  styleUrls: ['./autoreport.component.css']
})

export class AutoreportComponent implements OnInit {

  public urlToken: string;
  public emailToken: string;
  public password: string;
  public passwordEnc: string;
  public loginForm;
  public AutoReportRequest: AutoReportRequest;
  public AutoReportResponse: AutoReportResponse;
  public AutoReportResponseList: [AutoReportResponseList];
  public AutoReportResponseListSelectd: AutoReportResponseList;
  public FileReturn: string;
  public FileReturnData: Uint8Array;
  public loaded: boolean;
  public loginFailed: string;
  public opened: boolean;
  public data: any;
  public resultList = [];
  public pdfShow: boolean;
  public excelShow: boolean;

  constructor(private _router: Router, private route: ActivatedRoute, private fb: FormBuilder, private http: HttpClient) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.urlToken = params['id'];
      this.emailToken = params['emailToken'];
    });

    this.createForm();
  }

  private createForm(): void {
    this.loginForm = this.fb.group({
      password: ['', Validators.required]
    });
  }

  public submitted() {

    this.password = this.loginForm.value.password
    this.passwordEnc =  encodeURIComponent(this.encryptWeb(this.loginForm.value.password));

    if (this.AutoReportResponseList == null) {
      this.AutoReportRequestSubmitGetList();
    }

    this.AutoReportRequestSubmit();
  }

  encryptWeb(msg) {
    var keySize = 256;
    var salt = CryptoJS.lib.WordArray.random(16);
    var key = CryptoJS.PBKDF2('dsAS5643fdsFDSAd323', salt, {
      keySize: keySize / 32,
      iterations: 100
    });
    var iv = CryptoJS.lib.WordArray.random(128 / 8);
    var encrypted = CryptoJS.AES.encrypt(msg, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
    var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));
    return result;
  }

downloadFile(){
  var byteCharacters = atob(this.AutoReportResponse.attachment);
  var byteNumbers = new Array(byteCharacters.length);
                              for (var i = 0; i < byteCharacters.length; i++) {
                                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                              }

  var byteArray = new Uint8Array(byteNumbers);

  var blob = new Blob([byteArray], { type: this.AutoReportResponse.attachmentType });
  saveAs(blob, this.AutoReportResponse.attachmentName);
}

  AutoReportRequestSubmit() {

    var body: string;

    if (this.AutoReportResponseListSelectd != null) {
      let AutoReportRequest: AutoReportRequest = {
        urlToken: this.AutoReportResponseListSelectd.token,
        password: this.passwordEnc
      }

      body = JSON.stringify(AutoReportRequest)
    }
    else {
      let AutoReportRequest: AutoReportRequest = {
        urlToken: this.urlToken,
        password: this.passwordEnc
      }

      body = JSON.stringify(AutoReportRequest)
    }

        this.http.post(GlobalVariable.BASE_API_URL + "/api/AutoReportRequest", body.toString())
            .subscribe(
            (response) => {

              this.AutoReportResponse = <AutoReportResponse>response;

              if (this.AutoReportResponse.attachment.length > 10){
          this.loaded = true;
        }
              var byteCharacters = atob(<string>this.AutoReportResponse.attachment);
              var byteNumbers = new Array(byteCharacters.length);
                                    for (var i = 0; i < byteCharacters.length; i++) {
                                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                                    }

              var byteArray = new Uint8Array(byteNumbers);
              this.FileReturnData = byteArray;

              if (this.AutoReportResponse.attachmentType == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                var workbook = XLSX.read(byteCharacters, { type: "binary" });
                var first_sheet_name = workbook.SheetNames[0];
                var worksheet = workbook.Sheets[first_sheet_name];

                this.data = (XLSX.utils.sheet_to_json(worksheet, { header: 1 }));
                this.excelShow = true;
              }
              else {
                this.pdfShow = true;
              }
            },
            (err) => {
                /* this function is executed when there's an ERROR */
              console.log(err.status);

              if (err.status = 401) {
                this.loginFailed = "Invalid password or past 15 days."
              }

            },
            () => {
                /* this function is executed when the observable ends (completes) its stream */
                //this.openSnackBar("Set Batches has completed.", "OK");
            }
            );
 }

  AutoReportRequestSubmitGetList() {

    let AutoReportRequest: AutoReportRequest = {
      urlToken: this.urlToken,
      password: this.passwordEnc,
      emailToken: this.emailToken
    }

    var body = JSON.stringify(AutoReportRequest)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/AutoReportRequestList", body.toString())
      .subscribe(
        (response) => {

          this.AutoReportResponseList = <[AutoReportResponseList]>response;
         // console.log(this.AutoReportResponseList)

          this.AutoReportResponseList.forEach(r =>
            r.pharmName = r.attachmentName.substring(
              r.attachmentName.indexOf("^") + 1,
              r.attachmentName.lastIndexOf("^")
            )
          )

          var groups = new Set(this.AutoReportResponseList.map(item => new Date(item.filedate).toDateString() + ' ' + item.pharmName))
          
          groups.forEach(g =>
            this.resultList.push({
              name: g,
              values: this.AutoReportResponseList.filter(i => new Date(i.filedate).toDateString() + ' ' + i.pharmName  === g)
            }
            ))
        },
        (err) => {
          /* this function is executed when there's an ERROR */
          //console.log(err.status);

          if (err.status = 401) {
            this.loginFailed = "Invalid password or past 15 days."
          }

        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
        }
      );
  }

  DocListClick(obj: AutoReportResponseList) {

    this.AutoReportResponseListSelectd = obj;

    let AutoReportRequest: AutoReportRequest = {
      urlToken: obj.token,
      password: this.passwordEnc,
      attachmentName : obj.attachmentName
    }

    var body = JSON.stringify(AutoReportRequest)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/AutoReportRequest", body.toString())
      .subscribe(
        (response) => {

          this.AutoReportResponse = <AutoReportResponse>response;

          if (this.AutoReportResponse.attachment.length > 10) {
            this.loaded = true;
          }
          var byteCharacters = atob(<string>this.AutoReportResponse.attachment);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);
          this.FileReturnData = byteArray;

          if (this.AutoReportResponse.attachmentType == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            var workbook = XLSX.read(byteCharacters, { type: "binary" });
            var first_sheet_name = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[first_sheet_name];

            this.data = (XLSX.utils.sheet_to_json(worksheet, { header: 1 }));
            this.pdfShow = false;
            this.excelShow = true;
          }
          else {
            this.pdfShow = true;
            this.excelShow = false;
          }
        },
        (err) => {
          /* this function is executed when there's an ERROR */
          //console.log(err.status);

          if (err.status = 401) {
            this.pdfShow = false;
            this.excelShow = false;
            this.loaded = false;
            this.loginFailed = "Invalid password, document has different password, or past 15 days."
          }

        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/autoreport/autoreport.component.ts